import { useContext, useState } from "react"
import { Context } from "../../../utils/context"


const useCardLevels = (props) => {


    const { axios, authData, permissions } = useContext(Context)
    const authToken = `Bearer ${authData.token}`

    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [error, setError] = useState()
    const [cardlevels, setCardLevels] = useState([])
    
    const actions = {
        onGetCardLevels: async(idProgram) => {
            let response = []
            setLoading(true)
            try {
                axios.defaults.headers.common['Authorization'] = authToken
                const cardlevel_rq = await axios.get(`/cardLevel/program/${idProgram}/all`)
                setCardLevels(cardlevel_rq?.data?.data??[])
                response = cardlevel_rq.data.data
            } catch (error) {
                
            }
            setLoading(false)
            return response
        },
        onUpdateCardLevel: async(idCardLevel, idProgram, data) => {
            setSending(true)
            try {
                axios.defaults.headers.common['Authorization'] = authToken
                await axios.put(`/cardLevel/${idCardLevel}/program/${idProgram}`, data)
            } catch (error) {
                setError('We cannot proceed your request, try again')
            }
            setSending(false)
        }
    }

    const system = {loading, error}
    const data = {cardlevels}

    return {actions, system, data}
    
}

export default useCardLevels